import { IAuth, IUserLoginAction, IUserRoleAction } from 'src/types/auth/state';
import { IAction } from './actions';
import * as types from './constants';

const initialState: IAuth = {
  isLoggedin: false,
  userData: {
    name: undefined,
    role: [],
    roleName: '',
    id: null,
    treeRole: {},
    logo: '',
  },
  loading: {
    role: true,
  },
};

type Action = IAction<
  IUserLoginAction &
  IUserRoleAction
>;

export default function reducer(state = initialState, actions: Action): IAuth {
  switch (actions.type) {
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedin: true,
        userData: {
          ...state.userData,
          id: actions.payload.uid,
        },
      };
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedin: false,
      };
    case types.GET_USER_ROLE:
      return {
        ...state,
        loading: {
          ...state.loading,
          role: actions.payload.loading,
        },
      };
    case types.MAP_USER_ROLE:
      return {
        ...state,
        userData: {
          ...state.userData,
          role: actions.payload.role,
          roleName: actions.payload.roleName,
          treeRole: actions.payload.treeRole,
          name: actions.payload.name,
          logo: actions.payload.logo,
        },
        loading: {
          ...state.loading,
          role: false,
        },
      };
    default:
      return state;
  }
}
